import { render, staticRenderFns } from "./BriefcaseBusinessIcon.vue?vue&type=template&id=ca4eab3a"
import script from "./BriefcaseBusinessIcon.vue?vue&type=script&lang=js"
export * from "./BriefcaseBusinessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports